@if (disabled) { @if (selected != null) {
<partner-ingot [partner]="selected"></partner-ingot>
} @if (selected == null) {
<no-data class="form-control disabled-msg">
  No partner selected (disabled)
</no-data>
} } @if (!disabled) { @if (selected != null) {
<removable (remove)="clear()">
  <partner-ingot [partner]="selected"></partner-ingot>
</removable>
} @if (selected == null) {
<a (click)="openDialog()">
  <no-data class="form-control">{{ placeholder }}</no-data>
</a>
} }
